<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Advanced Import Options</h6>
        <div>
          <a-collapse accordion :activeKey="activeKey">
            <a-collapse-panel header="Parent Products" key="1">
              <a-upload-dragger :remove="handleRemoveProducts" :fileList="productList" :beforeUpload="beforeUploadProducts" :multiple="false">
                <span class="fa fa-file-import" style="font: 20pt" />
                <p class="ant-upload-text">
                  Click or drag product file to this area to upload
                </p>
                <p class="ant-upload-hint">
                  Upload your product list in a CSV file following the specified
                  format. You can download templates below.
                </p>
              </a-upload-dragger>

              <a-list bordered>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to import products">
                    <a @click.prevent="downloadTemplate('products')" slot="title">Download Advanced Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('products')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
              </a-list>

              <div>
                <button type="button" class="btn btn-primary float-right" @click.prevent="importFile('products')">
                  Import
                </button>
              </div>
            </a-collapse-panel>
            <a-collapse-panel header="Combo Groups and Values" key="2">
              <a-upload-dragger :remove="handleRemoveCombos" :fileList="comboList" :beforeUpload="beforeUploadCombos" :multiple="false">
                <span class="fa fa-file-import" style="font: 20pt" />
                <p class="ant-upload-text">
                  Click or drag combo file to this area to upload
                </p>
                <p class="ant-upload-hint">
                  Upload your combo list in a CSV file following the specified
                  format. You can download templates below.
                </p>
              </a-upload-dragger>

              <a-list bordered>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to import combo groups and values">
                    <a @click.prevent="downloadTemplate('combos')" slot="title">Download Combo Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('combos')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
              </a-list>

              <div>
                <button type="button" class="btn btn-primary float-right" @click.prevent="importFile('combos')">
                  Import
                </button>
              </div>
            </a-collapse-panel>
            <a-collapse-panel header="Prices" key="3">
              <a-upload-dragger :remove="handleRemovePrices" :fileList="priceList" :beforeUpload="beforeUploadPrices" :multiple="false">
                <span class="fa fa-file-import" style="font: 20pt" />
                <p class="ant-upload-text">
                  Click or drag price file to this area to upload
                </p>
                <p class="ant-upload-hint">
                  Upload your price list in a CSV file following the specified
                  format. You can download templates below.
                </p>
              </a-upload-dragger>

              <a-list bordered>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to import price entries">
                    <a @click.prevent="downloadTemplate('prices')" slot="title">Download Price Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('prices')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
              </a-list>

              <div>
                <button type="button" class="btn btn-primary float-right" @click.prevent="importFile('prices')">
                  Import
                </button>
              </div>
            </a-collapse-panel>
          </a-collapse>
          <br /><br />
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";

var component_x;

export default {
  name: 'ProductAdvancedImportForm',
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "profileId",
      "parameters",
      "parentId",
      "serverType",
    ])
  },

  data() {
    return {
      productList: [],
      comboList: [],
      priceList: [],
      activeKey: '1',
    };
  },

  mounted() {
    component_x = this
  },

  methods: {
    // products
    handleRemoveProducts(file) {
      const index = this.productList.indexOf(file);
      const newProductList = this.productList.slice();
      newProductList.splice(index, 1);
      this.productList = newProductList;
    },
    handleRemoveCombos(file) {
      const index = this.comboList.indexOf(file);
      const newComboList = this.comboList.slice();
      newComboList.splice(index, 1);
      this.comboList = newComboList;
    },
    handleRemovePrices(file) {
      const index = this.priceList.indexOf(file);
      const newPriceList = this.priceList.slice();
      newPriceList.splice(index, 1);
      this.priceList = newPriceList;
    },
    beforeUploadProducts(file) {
      this.productList = [...this.productList, file];
      return false;
    },
    beforeUploadCombos(file) {
      this.comboList = [...this.comboList, file];
      return false;
    },
    beforeUploadPrices(file) {
      this.priceList = [...this.priceList, file];
      return false;
    },
    async importFile(profile) {
      console.log(profile)
      let formData = new FormData();
      formData.append("profile_name", profile);
      switch (profile) {
        case "products":
          formData.append("file", this.productList[0]);
          break;
        case "combos":
          formData.append("file", this.comboList[0]);
          break;
        case "prices":
          formData.append("file", this.priceList[0]);
          break;
      }
      console.log(formData)
      await axios({
        method: "post",
        url: this.endPoint + "importers/upload_file",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
        data: formData,
      }).then(async function (m) {
        // alert(m.data.file_name)
        var payload = {
          import_job: { profile_name: profile, file_name: m.data.file_name },
        };
        var response = await HTTPRequest.postRequest(
          component_x.endPoint + "/import_jobs",
          null,
          payload
        );
        if (response.id != null) {
          component_x.$notification["success"]({
            message: "Successful Operation",
            description:
              "File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
            placement: 'bottomRight',
            btn: (h) => {
              return h(
                "base-button",
                {
                  props: {
                    type: "primary",
                    class: "btn-sm",
                  },
                  on: {
                    click: () => component_x.$router.push("/jobs"),
                  },
                },
                "View Jobs"
              );
            },
          });
          component_x.drawerVisible = false;
          component_x.productList = [];
          component_x.comboList = [];
          component_x.priceList = [];
          this.activeKey = this.activeKey == '3' ? '0' : (parseInt(this.activeKey) + 1).toString()
        }
        // console.log(response)
      });
      // .catch(function () {
      //     alert("NOT OKAY")
      // });
    },
    downloadTemplate(profile) {
      var urlDownload =
          this.endPoint +
          `import_templates/download_file?profile_name=${profile}&type=advanced`;
      axios({
        url: urlDownload,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${profile}_import_template.csv`);
        document.body.appendChild(link);
        link.click();
        component_x.$notification["success"]({
          message: "Successful Download",
          description:
            `You have succesfully downloaded the template for ${profile} upload.`,
        });
      });
    },

  },
};
</script>
<style>
  .ant-collapse-content-box {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
</style>

